// extracted by mini-css-extract-plugin
module.exports = {"bottom__steps":"MainMenuSteps_bottom__steps__2hqEg","bottom__steps-wrapper":"MainMenuSteps_bottom__steps-wrapper__3kgUN"};